class SoundwaveVisualizer {
  constructor(options = {}) {
    this.config = {
      containerId: 'soundwave',
      animationDuration: 2.5,
      barClass: 'bar',
      breakpoints: {
        small: 30, // for small screens
        medium: 50, // for medium screens
        large: 70 // for large screens
      },
      ...options
    };

    this.config.barCount = this.getBarCount();
  }

  getBarCount() {
    const width = window.innerWidth;

    if (width < 600) {
      return this.config.breakpoints.small; // Small screens
    }

    if (width >= 600 && width < 1024) {
      return this.config.breakpoints.medium; // Medium screens
    }

    return this.config.breakpoints.large; // Large screens
  }

  init() {
    try {
      this.createSoundwave();
      window.addEventListener('resize', this.onResize.bind(this));
    } catch (error) {
      console.error('Error initializing SoundwaveVisualizer:', error);
    }
  }

  onResize() {
    const newBarCount = this.getBarCount();
    if (newBarCount !== this.config.barCount) {
      this.config.barCount = newBarCount;
      this.createSoundwave();
    }
  }

  createSoundwave() {
    const container = document.getElementById(this.config.containerId);
    if (!container) {
      console.warn(`Container with id "${this.config.containerId}" not found.`);
      return;
    }

    container.innerHTML = ''; // Clear any existing content

    for (let i = 0; i < this.config.barCount; i += 1) {
      const bar = document.createElement('div');
      bar.className = this.config.barClass;
      bar.style.animationDelay = `${(i / this.config.barCount) * this.config.animationDuration}s`;
      container.appendChild(bar);
    }
  }
}

export default SoundwaveVisualizer;
